<form [formGroup]="permissionsForm">
  <!-- CATALOGUE -->
  @if (isGroupVisible('catalogue')) {
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.CATALOGUE.TITLE' | translate }}</h4>
      <button
        class="color-primary bg-white border-0"
        (click)="setControlsGroupValue('catalogue', !disableAllAvailable('catalogue'))"
      >
        {{ (disableAllAvailable('catalogue') ? 'MANAGED_USERS.DISABLE_ALL' : 'MANAGED_USERS.ENABLE_ALL') | translate }}
      </button>
    </div>

    <p class="color-gray-600 mt-2">{{ 'MANAGED_USERS.USER_PERMISSIONS.CATALOGUE_PERMISSIONS_INFO' | translate }}</p>

    <div class="pb-2r border-bottom">
      @if (isControlVisible('viewCatalogue')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewCatalogue"
            type="checkbox"
            class="form-check-input"
            data-testid="viewCataloguePermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_CATALOGUE' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('showPrices')) {
        <div class="form-check mt-3">
          <input
            formControlName="showPrices"
            type="checkbox"
            class="form-check-input"
            data-testid="showPricesPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.SHOW_PRICES' | translate"
          ></span>
        </div>
      }

      @if (userCompanyHasDiscount && isControlVisible('showPricelistDiscount')) {
        <div class="form-check mt-3">
          <input
            formControlName="showPricelistDiscount"
            type="checkbox"
            class="form-check-input"
            data-testid="showPricelistDiscountPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.SHOW_PRICELIST_DISCOUNT' | translate"
          ></span>
        </div>
      }
    </div>
  }

  <!-- OFFERS -->
  @if (isGroupVisible('offers')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.ORDERS.OFFERS' | translate }}</h4>
      @if (disableAllAvailable('offers')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('offers', false)">
          {{ 'MANAGED_USERS.DISABLE_ALL' | translate }}
        </button>
      } @else if (enableAllAvailable('offers')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('offers', true)">
          {{ 'MANAGED_USERS.ENABLE_ALL' | translate }}
        </button>
      }
    </div>

    <div class="pb-2r border-bottom">
      @if (isControlVisible('viewAndCreateOffers')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewAndCreateOffers"
            type="checkbox"
            class="form-check-input"
            data-testid="viewAndCreateOffersPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_AND_CREATE_OFFERS' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('createOrders')) {
        <div class="form-check mt-3">
          <input
            formControlName="createOrders"
            type="checkbox"
            class="form-check-input"
            data-testid="createOrdersPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.SEND_ORDERS' | translate"
          ></span>
        </div>
      }
    </div>
  }

  <!-- ORDERS -->
  @if (isGroupVisible('orders')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.ORDERS.TITLE' | translate }}</h4>
      @if (disableAllAvailable('orders')) {
        <button
          class="color-primary bg-white border-0"
          (click)="setControlsGroupValue('orders', false)"
          data-testid="ordersDisableAll"
        >
          {{ 'MANAGED_USERS.DISABLE_ALL' | translate }}
        </button>
      } @else if (enableAllAvailable('orders')) {
        <button
          class="color-primary bg-white border-0"
          (click)="setControlsGroupValue('orders', true)"
          data-testid="ordersEnableAll"
        >
          {{ 'MANAGED_USERS.ENABLE_ALL' | translate }}
        </button>
      }
    </div>

    <div class="pb-2r border-bottom">
      @if (isControlVisible('viewOrders')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewOrders"
            type="checkbox"
            class="form-check-input"
            data-testid="viewOrdersPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_ORDERS' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('viewOrdersOnCompanyLevel')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewOrdersOnCompanyLevel"
            type="checkbox"
            class="form-check-input"
            data-testid="viewOrdersOnCompanyLevelPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_ORDERS_ON_COMPANY_LEVEL' | translate"
          ></span>
        </div>
      }
    </div>
  }

  <!-- PROJECT RESERVATIONS -->
  @if (isGroupVisible('projectReservations')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.INQUIRIES.PROJECT_RESERVATIONS' | translate }}</h4>
      @if (disableAllAvailable('projectReservations')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('projectReservations', false)">
          {{ 'MANAGED_USERS.DISABLE_ALL' | translate }}
        </button>
      } @else if (enableAllAvailable('projectReservations')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('projectReservations', true)">
          {{ 'MANAGED_USERS.ENABLE_ALL' | translate }}
        </button>
      }
    </div>

    <div class="pb-2r border-bottom">
      @if (isControlVisible('viewAndCreateProjectReservations')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewAndCreateProjectReservations"
            type="checkbox"
            class="form-check-input"
            data-testid="viewAndCreateProjectReservationsPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_AND_CREATE_PROJECT_RESERVATIONS' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('viewProjectReservationsOnCompanyLevel')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewProjectReservationsOnCompanyLevel"
            type="checkbox"
            class="form-check-input"
            data-testid="viewProjectReservationsOnCompanyLevelPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_PROJECT_RESERVATIONS_ON_COMPANY_LEVEL' | translate"
          ></span>
        </div>
      }
    </div>
  }

  <!-- CMPR -->
  @if (isGroupVisible('cmpr')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.INQUIRIES.CUSTOM_MADE_PRICE_REQUESTS' | translate }}</h4>
      @if (disableAllAvailable('cmpr')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('cmpr', false)">
          {{ 'MANAGED_USERS.DISABLE_ALL' | translate }}
        </button>
      } @else if (enableAllAvailable('cmpr')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('cmpr', true)">
          {{ 'MANAGED_USERS.ENABLE_ALL' | translate }}
        </button>
      }
    </div>

    <div class="pb-2r border-bottom">
      @if (isControlVisible('viewCmprs')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewCmprs"
            type="checkbox"
            class="form-check-input"
            data-testid="viewCmprsPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_CMPRS' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('createCmprs')) {
        <div class="form-check mt-3">
          <input
            formControlName="createCmprs"
            type="checkbox"
            class="form-check-input"
            data-testid="createCmprsPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.CREATE_CMPRS' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('viewCmprsOnCompanyLevel')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewCmprsOnCompanyLevel"
            type="checkbox"
            class="form-check-input"
            data-testid="viewCmprsOnCompanyLevelPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_CMPRS_ON_COMPANY_LEVEL' | translate"
          ></span>
        </div>
      }
      @if (isControlVisible('viewCustomMadePriceEstimates')) {
        <div class="form-check mt-3">
          <input id="view-custom-made-price-estimates" formControlName="viewCustomMadePriceEstimates"
            type="checkbox" class="form-check-input" data-testid="viewCustomMadePriceEstimatesPermission" />
          <label for="view-custom-made-price-estimates" class="color-black d-block">
            {{ 'CUSTOM_MADE_PRICE_ESTIMATES.PERMISSION' | translate }}
          </label>
        </div>
      }
    </div>
  }

  <!-- CLAIMS -->
  @if (isGroupVisible('claims')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4
        class="color-gray-500 fw-bold m-0"
        data-testid="claimsSectionTitle"
      >
        {{ 'NAVBAR.INQUIRIES.CLAIMS' | translate }}
      </h4>
      @if (disableAllAvailable('claims')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('claims', false)">
          {{ 'MANAGED_USERS.DISABLE_ALL' | translate }}
        </button>
      } @else if (enableAllAvailable('claims')) {
        <button class="color-primary bg-white border-0" (click)="setControlsGroupValue('claims', true)">
          {{ 'MANAGED_USERS.ENABLE_ALL' | translate }}
        </button>
      }
    </div>

    <div class="pb-2r border-bottom">
      @if (isControlVisible('viewAndCreateClaims')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewAndCreateClaims"
            type="checkbox"
            class="form-check-input"
            data-testid="viewAndCreateClaimsPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_AND_CREATE_CLAIMS' | translate"
          ></span>
        </div>
      }

      @if (isControlVisible('viewClaimsOnCompanyLevel')) {
        <div class="form-check mt-3">
          <input
            formControlName="viewClaimsOnCompanyLevel"
            type="checkbox"
            class="form-check-input"
            data-testid="viewClaimsOnCompanyLevelPermission"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_CLAIMS_ON_COMPANY_LEVEL' | translate"
          ></span>
        </div>
      }
    </div>
  }

  <!-- INFORMATION -->
  @if (isGroupVisible('infoPages')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.INFO.LINK' | translate }}</h4>
      <button
        class="color-primary bg-white border-0"
        (click)="setControlsGroupValue('infoPages', !disableAllAvailable('infoPages'))"
        data-testid="setInfoPagesControls"
      >
        {{ (disableAllAvailable('infoPages') ? 'MANAGED_USERS.DISABLE_ALL' : 'MANAGED_USERS.ENABLE_ALL') | translate }}
      </button>
    </div>

    <div class="pb-2r border-bottom">
      @for (infoPagePermission of infoPagesPermissions; track $index) {
        <div class="form-check mt-3">
          <input
            [formControlName]="infoPagePermission.value"
            type="checkbox"
            class="form-check-input"
            data-testid="infoPageControl"
          />
          <span
            class="color-black d-block"
            [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_INFORMATION_PAGE' | translate: { page: infoPagePermission.label }"
          ></span>
        </div>
      }
    </div>
  }

  <!-- ORDERS LEAD TIME -->
  @if (isGroupVisible('ordersLeadTime')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'NAVBAR.ESTIMATES.LINK' | translate }}</h4>
      <button
        class="color-primary bg-white border-0"
        (click)="setControlsGroupValue('ordersLeadTime', !disableAllAvailable('ordersLeadTime'))"
      >
        {{ (disableAllAvailable('ordersLeadTime') ? 'MANAGED_USERS.DISABLE_ALL' : 'MANAGED_USERS.ENABLE_ALL') | translate }}
      </button>
    </div>

    <div class="pb-2r border-bottom">
      <div class="form-check mt-3">
        <input
          formControlName="viewEstimatedLeadTimePage"
          type="checkbox"
          class="form-check-input"
        />
        <span
          class="color-black d-block"
          [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_ESTIMATED_LEAD_TIME_PAGE' | translate"
        ></span>
      </div>
    </div>
  }

  <!-- COMPANY PROFILE -->
  @if (isGroupVisible('companyProfile')) {
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h4 class="color-gray-500 fw-bold m-0">{{ 'COMPANY_ACCOUNT.TITLE' | translate }}</h4>
      <button
        class="color-primary bg-white border-0"
        (click)="setControlsGroupValue('companyProfile', !disableAllAvailable('companyProfile'))"
      >
        {{ (disableAllAvailable('companyProfile') ? 'MANAGED_USERS.DISABLE_ALL' : 'MANAGED_USERS.ENABLE_ALL') | translate }}
      </button>
    </div>

    @if (isControlVisible('viewCompanyInformation')) {
      <div class="form-check mt-3">
        <input
          formControlName="viewCompanyInformation"
          type="checkbox"
          class="form-check-input"
        />
        <span
          class="color-black d-block"
          [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_COMPANY_INFORMATION' | translate"
        ></span>
      </div>
    }

    @if (isControlVisible('viewPurchaseAndSalesAgreement')) {
      <div class="form-check mt-3">
        <input
          formControlName="viewPurchaseAndSalesAgreement"
          type="checkbox"
          class="form-check-input"
        />
        <span
          class="color-black d-block"
          [innerHTML]="'MANAGED_USERS.USER_PERMISSIONS.VIEW_PURCHASE_AND_SALES_AGREEMENT' | translate"
        ></span>
      </div>
    }
  }
</form>
